export const projects = [
  {
    id: 1,
    title: "JAVA E-Sports App (DB)",
    description:
      "En desktop Java-applikation til håndtering af e-sports begivenheder, hold, spil og konkurrence resultater understøttet af en MySQL-database. " +
      "Registrer kampresultater med inputvalidering (f.eks. forhindre duplikerede hold og sikre fornuftige scores), opdater eller slet poster, " +
      "og opfrisk øjeblikkeligt stillinger for at spore holdpræstationer på tværs af flere konkurrencer. " +
      "Brugergrænsefladen er organiseret i klare faner til at gennemse resultater, tilføje nye resultater, oprette/opdatere hold og registrere begivenheder, " +
      "med filtrerbare tabeller (efter begivenhed eller hold) for hurtigt at finde det, du har brug for. " +
      "Databaseadgang håndteres via et dedikeret læse-/skrive-lag ved hjælp af parameteriseret SQL. " +
      "Eksporter tabeller til CSV til rapportering, og hold udrulningen fleksibel ved at indlæse databaseforbindelsen fra en ekstern konfiguration. " +
      "Bygget i NetBeans for at demonstrere ren OOP-struktur, fejlhåndtering og praktisk databaseintegration i et virkeligt scenarie.",
    category: "JAVA",
    operatingSystems: ["Windows"],
    imageUrl: "/uploads/images/E-Sports-App-DB.png",
    zipUrlMac: "/uploads/zips/E-Sports-App-DBMac.zip",
    zipUrlWin: "/uploads/zips/E-Sports-App-DBWin.zip",
    githubUrl: "https://github.com/LSchouG",
    buttonText: "Se Projekt",
    externalLink: false,
    createdAt: Date.now()
  },
{
  id: 2,
  title: "Adventure Game",
  description: "A 2D tile-based role-playing game (RPG) developed in Java, where players embark on an epic quest to explore maps,"+
  " battle a variety of monsters, and defeat the formidable Golem Lord to rescue four captive villagers and unlock the Town’s Treasure Chest."+
  " Players engage in combat with enemies like Green Slimes, Skeletons, Spiders, and Bats, while collecting loot from chests containing swords, "+
  "shields, and a pickaxe. The game features persistent player stats (level, health, mana, strength, dexterity), inventory, and map objects,"+
  " ensuring seamless continuation across sessions. Dynamic cutscenes — including a cinematic boss battle introduction — and NPC dialogues add "+
  "depth to exploration. Conditional asset placement (e.g., relocating rescued villagers to the town after defeating the boss) is driven by "+
  "progress flags. Built with a modular object-oriented programming (OOP) structure, the codebase is organized into packages for entities, "+
  "monsters, objects, and data management, showcasing clean design and robust state handling.",
  category: "JAVA",
  operatingSystems: ["Windows", "macOS"],
  imageUrl: "/uploads/images/AdventureGame.png",
  zipUrlMac: "/uploads/zips/AdventureGameMac.zip",
  zipUrlWin: "/uploads/zips/AdventureGameWin.zip",
  githubUrl: "https://github.com/LSchouG",
  buttonText: "Se Projekt",
  externalLink: false,
  createdAt: Date.now()
},
{
    id: 3,
    title: "JAVA E-Sports App (CSV)",
    description:
      "En desktop Java-applikation til håndtering af e-sports hold, begivenheder og konkurrence resultater ved hjælp af simple CSV-filer—ingen database kræves. " +
      "Indlæs Teams.csv og Competitions.csv ved opstart, registrer nye kampresultater (dato, sted, spil, hold, point), opdater holddetaljer og gem ændringer tilbage til CSV for nem deling og backup. " +
      "Brugergrænsefladen grupperer opgaver i overskuelige faner til visning af resultater og en hurtig rangliste, tilføjelse af resultater og oprettelse/opdatering af hold, med filtrerbare tabeller for hurtigt at finde data. " +
      "Inputvalidering forhindrer ugyldige indtastninger (f.eks. kun numeriske point og ingen tomme felter), mens dubletter/ugyldige valg håndteres elegant. " +
      "Under overfladen demonstrerer den kerne-OOP: dedikerede datamodelklasser, flere konstruktører, metodeoverbelastning og brug af arrays/ArrayLists til hukommelseslagring, sortering og visning. " +
      "Designet som en letvægts, bærbar prototype, der følger rene navngivnings-/layout-/dokumentationsstandarder og understøtter eksport af opdaterede CSV-filer til rapportering.",
    category: "JAVA",
    operatingSystems: ["Windows"],
    imageUrl: "/uploads/images/E-Sports-App-CSV.png",
    zipUrlMac: "/uploads/zips/E-Sports-App-CSVMac.zip",
    zipUrlWin: "/uploads/zips/E-Sports-App-CSVWin.zip",
    githubUrl: "https://github.com/LSchouG",
    buttonText: "Se Projekt",
    externalLink: false,
    createdAt: Date.now()
  },
  {
    id: 4,
    title: "C# Klasselokale Manager",
    description: 
      "En desktop C#-applikation til at designe og administrere en siddeplan for et klasselokale. " +
      "Importer en CSV-fil for at vise lokalet som et gitter af pulte, opdater elevnavne og placeringer, " +
      "og ryd layoutet, når du starter en ny klasse. " +
      "Gem ændringer tilbage til CSV eller brug 'Gem Som' til at gemme opdaterede detaljer om lærer, klasse, lokale og dato. " +
      "Organiser klassen hurtigt med en alfabetisk elevliste, der inkluderer hver pults placering, " +
      "og find elever hurtigt—søgning bruger en binær søgning og fremhæver match i gitteret. " +
      "Appen kan også skrive til en Random Access File for direkte adgang til poster. " +
      "Bygget til ICTPRG443 Klasselokale Manager-projektet og i overensstemmelse med standard kodnings-/dokumentationspraksisser.",
    category: "C#",
    operatingSystems: ["Windows"],
    imageUrl: "/uploads/images/ClassroomManager.png",
    zipUrlWin: "/uploads/zips/ClassroomManagerWin.zip",
    githubUrl: "https://github.com/LSchouG",
    buttonText: "Se Projekt",
    externalLink: false,
    createdAt: Date.now()
  },
  {
    id: 5,
    title: "C# Matematikspørgsmål (CSV)",
    description:
      "En desktop C#-applikation til at køre live lærer-elev matematikquizzer over det lokale netværk. " +
      "Læreren opretter spørgsmål (opgave og korrekt svar) og sender dem til tilsluttede elevklienter via en baggrundsnetværkstråd, " +
      "mens eleverne indsender svar i realtid. " +
      "Lærervisningen indsamler svar, optæller point og registrerer tidsstempler for hver forsøg. " +
      "Alle spørgsmål gemmes i en List<Question> for den aktive session, og eventuelle forkerte svar sættes i kø i en LinkedList til målrettet gennemgang og genforsøg. " +
      "Spørgsmålssæt og resultater kan gemmes til og indlæses fra CSV-filer, hvilket gør det nemt at arkivere sessioner eller forberede øvelsessæt. " +
      "Bygget til at demonstrere OOP-principper (brugerdefinerede klasser, metoder, samlinger) og praktisk fil-I/O til ICTPRG430/549-porteføljen.",
     category: "C#",
    operatingSystems: ["Windows"],
    imageUrl: "/uploads/images/MathQuestion.png",
     zipUrlWin: "/uploads/zips/MathQuestionWin.zip",
    githubUrl: "https://github.com/LSchouG",
    buttonText: "Se Projekt",
    externalLink: false,
    createdAt: Date.now()
  },  {
    id: 6,
    title: "C# Genbrugere (CSV)",
    description:
      "Et desktop C#-værktøj til at designe og administrere siddeplaner for klasselokaler. " +
      "Tildel eller omdøb elever, opdater siddeplaceringer og hold layoutet synkroniseret, når din klasse ændres. " +
      "Importer en eksisterende plan fra CSV, gem derefter opdateringer tilbage til CSV—eller brug Gem Som til at versionere layouts med detaljer om lærer, klasse, lokale og dato. " +
      "Find elever hurtigt med navnesøgning (fremhæver deres pult) og se en alfabetiseret liste, der afspejler gitteret. " +
      "Inkluderer ryd/nulstil for nye klasser og simple navigationshjælpere til at gå gennem elever. " +
      "Bygget til ICTPRG443 Klasselokale Manager-projektet og dokumenteret efter Downtown IT-standarder.",
      category: "C#",
    operatingSystems: ["Windows"],
    imageUrl: "/uploads/images/recyclers.png",
     zipUrlWin: "/uploads/zips/RecyclersWin.zip",
    githubUrl: "https://github.com/LSchouG",
    buttonText: "Se Projekt",
    externalLink: false,
    createdAt: Date.now()
  }
];




export default projects;
